module.exports = __webpack_public_path__ + "static/media/logo.f7a0ce16.svg";